<template>
  <section>
    <br>
    <h1 class="title">
      {{ $root.pageTitle }}
    </h1>
    <div class="columns">
      <div class="column is-12 is-paddingless has-text-centered">
        <br>
        <img
          src="/assets/img/not_found.svg"
          alt="Page not found"
        >
        <br>
        <p>
          If you entered a web address please check it was correct.<br>
          Be sure you're logged with an account which can access this resources.
        </p>

        <p>
          <a
            class="button primary"
            href="/"
          >Go to Homepage</a>
        </p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'PageNotFound',
  data() {
    return {
      info: null
    };
  },
  mounted() {
    this.$root.pageTitle = "We didn't find that page";
  }
};
</script>
<style scoped>
    img {
        width: 100%;
        max-width: 250px;
        margin: 2rem 0;
    }
</style>
